var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circles only"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.651 3.95117H22.583V32.7029H38.651V3.95117Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.6468 18.3266C23.6455 15.5575 24.2769 12.8243 25.4932 10.3338C26.7095 7.84327 28.4788 5.66057 30.6674 3.95077C27.9569 1.8297 24.7015 0.510457 21.2732 0.14385C17.8449 -0.222756 14.3822 0.37807 11.2808 1.87764C8.17941 3.37721 5.56455 5.715 3.73513 8.62379C1.90571 11.5326 0.935547 14.895 0.935547 18.3266C0.935547 21.7583 1.90571 25.1207 3.73513 28.0295C5.56455 30.9383 8.17941 33.2761 11.2808 34.7756C14.3822 36.2752 17.8449 36.876 21.2732 36.5094C24.7015 36.1428 27.9569 34.8236 30.6674 32.7025C28.4776 30.9938 26.7073 28.8114 25.4909 26.3206C24.2745 23.8298 23.6439 21.0961 23.6468 18.3266Z",
    fill: "#E52423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M58.6269 29.6605V29.0699H58.8732V28.9473H58.2686V29.0699H58.5037V29.6605H58.6269ZM59.8138 29.6605V28.9473H59.6234L59.4107 29.4376L59.1979 28.9473H59.0076V29.6605H59.1419V29.1256L59.3435 29.5825H59.4779L59.6794 29.1256V29.6605H59.8138Z",
    fill: "#F99F1C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M42.021 0.0508003C37.9036 0.0448788 33.9041 1.41883 30.667 3.95123C32.8519 5.66372 34.618 7.84719 35.8323 10.3373C37.0466 12.8274 37.6775 15.5592 37.6775 18.3271C37.6775 21.095 37.0466 23.8268 35.8323 26.3169C34.618 28.807 32.8519 30.9905 30.667 32.703C32.9687 34.5013 35.6689 35.7261 38.5425 36.2754C41.4162 36.8246 44.3802 36.6825 47.1875 35.8608C49.9948 35.0391 52.5641 33.5615 54.6814 31.5513C56.7988 29.5411 58.4027 27.0564 59.3597 24.3042C60.3167 21.5521 60.599 18.6122 60.1831 15.7294C59.7672 12.8467 58.6651 10.1046 56.9687 7.73165C55.2723 5.35869 53.0307 3.42357 50.4306 2.08752C47.8305 0.751462 44.9472 0.0531638 42.021 0.0508003Z",
    fill: "#F99F1C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.2b3e39f0a4b2255659f3423a98e112a1.svg";
export { ForwardRef as ReactComponent };